var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.email
    ? _c("div", { staticClass: "register-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "announce-container" }, [
          _c("span", [
            _vm._v("以下のメールアドレス宛にメールをお送りしました。")
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "text-red" }, [
            _vm._v("メールに記載のパスワードからログインして下さい。")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", [_vm._v("メールアドレス")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "m-b-none" }, [_vm._v(_vm._s(_vm.email))])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", [_vm._v("メール送信が完了しました。")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31d43542", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31d43542","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/resetpassword/ConfirmEmail.vue
// module id = null
// module chunks = 